import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"

import SBProvider from "./components/sendbird/SBProvider"
import { isVercelDeployment } from "./constants"
import { queryClient } from "./queryClient"
import { Routing } from "./routing"
import "@joonapp/web-shared/dist/style.css"
import "@sendbird/uikit-react/dist/index.css"
import "./styles/tailwind.css"

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <SBProvider>
        <Routing />
        {import.meta.env.DEV && !isVercelDeployment && <ReactQueryDevtools />}
      </SBProvider>
    </QueryClientProvider>
  )
}

export default App
